import './3girls/style';
import FormStructure from './3girls/form_structure';

export default FormStructure;